module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_spirink_m.9f7eaa01e08c6bbb9a86e42c1c4680eb.png";